import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DropdownV2 from './DropdownV2';

const DropdownV2Adapter = ({ input, meta, onSelect, ...rest }) => {
  // this hook lets this component manage the state inside the dropdown
  const [value, setValue] = useState(null);
  const errorMessage = meta && meta.touched && meta.error ? meta.error : '';
  if (input && input.value !== value) {
    setValue(input.value);
  }
  return (
    <DropdownV2
      value={value}
      id={`dropdown-${input.name}`}
      onSelect={(val) => {
        console.log('onSelect getting called');
        console.log(val);
        if (onSelect) {
          // Lets you set state outside the component
          onSelect(val);
        }
        setValue(val);
        return input.onChange(val);
      }}
      errorMessage={errorMessage}
      {...rest}
    />
  );
};

DropdownV2Adapter.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    onChange: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    asyncValidating: PropTypes.bool,
  }).isRequired,
  onSelect: PropTypes.func,
};

export default DropdownV2Adapter;
